/*
 * Kapsul · Cart bundle helpers
 * - After ANY cart update, scan the cart for Melt Bar bundles that became
 *   partial (a line got removed → the box is broken). Wipe the leftovers
 *   atomically so the box never sits half-empty in the cart.
 * - Backup refresh for the cart-icon-bubble.
 */
(function () {
  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartEl() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  async function refreshBubble() {
    try {
      const r = await fetch(rootUrl() + '?sections=cart-icon-bubble');
      const d = await r.json();
      const html = d['cart-icon-bubble'];
      if (!html) return;
      const target = document.getElementById('cart-icon-bubble');
      if (!target) return;
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const wrap = tmp.querySelector('.shopify-section') || tmp.firstElementChild;
      target.innerHTML = wrap ? wrap.innerHTML : tmp.innerHTML;
    } catch (e) {}
  }
  window.kapsulRefreshBubble = refreshBubble;

  let cleanupRunning = false;
  async function cleanupPartialBundles() {
    if (cleanupRunning) return;
    cleanupRunning = true;
    try {
      const r = await fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await r.json();
      const bundles = {};
      (cart.items || []).forEach(function (it) {
        const id = it.properties && it.properties._kmm_bundle;
        if (!id) return;
        if (!bundles[id]) {
          bundles[id] = {
            box: parseInt((it.properties && it.properties._kmm_box) || '0', 10),
            scentQty: 0,
            items: []
          };
        }
        bundles[id].items.push(it);
        // Only the pastilla lines (no _kmm_addon flag) count toward the box size
        if (!(it.properties && it.properties._kmm_addon)) {
          bundles[id].scentQty += it.quantity;
        }
      });
      const updates = {};
      Object.keys(bundles).forEach(function (id) {
        const b = bundles[id];
        // Partial: pastilla qty doesn't match the declared box size → wipe everything
        if (b.box > 0 && b.scentQty !== b.box) {
          b.items.forEach(function (it) { updates[it.key] = 0; });
        }
      });
      if (Object.keys(updates).length === 0) return;

      const ce = cartEl();
      const body = { updates: updates };
      if (ce && typeof ce.getSectionsToRender === 'function') {
        body.sections = ce.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      const r2 = await fetch(rootUrl() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await r2.json();
      if (ce && typeof ce.renderContents === 'function') {
        try { ce.renderContents(data); } catch (e) {}
      }
      refreshBubble();
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kapsul-cart-bundle-cleanup', cartData: data });
        }
      } catch (e) {}
    } catch (e) {
      console.warn('[kapsul-cart-bundle] cleanup failed', e);
    } finally {
      cleanupRunning = false;
    }
  }

  function init() {
    // Initial sweep (in case the cart already has a partial bundle on load)
    cleanupPartialBundles();
    // After any cart update, sweep again
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
          if (ev && ev.source === 'kapsul-cart-bundle-cleanup') return;
          setTimeout(cleanupPartialBundles, 50);
        });
      }
    } catch (e) {}
    // Belt-and-braces fallback: a generic cart event
    window.addEventListener('cart:updated', function () { setTimeout(cleanupPartialBundles, 50); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
